import IDynamicFormRow from "../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";
import FormTextBox from "../yoello-lib/modules/dynamicForms/FormComponents/FormTextBox";
// import { ReactComponent as InfoCircleIcon } from "../assets/images/icon-info-circle.svg"
// import { AlertStatusCard } from "../yoello-lib/modules/components/UI/Alerts/AlertStatusCard";
import { InputAdornment } from "@material-ui/core";
import { FormTags } from "../yoello-lib/modules/dynamicForms/CustomFormComponents/FormTags";
import IVenue from "../interfaces/IVenue";
import FormSelect from "../yoello-lib/modules/dynamicForms/FormComponents/FormSelect";
import { ILanguage } from "../yoello-lib/modules/redux/actions/localization";



function validateGroupURL(value: string ,  t:(key:string) => string) { 
    const is_all_uppercase = value === value.toUpperCase()
    const regex = /^[a-zA-Z0-9-_]+\S*$/;
    return (regex.test(value) && !is_all_uppercase) || t('groups.form.error.URL');
}

export const groupForm = (t: (key: string) => string, venues:Partial<IVenue>[], languages: ILanguage[], loading:boolean, setInputValue:(text:string) => void, update?:boolean): IDynamicFormRow[] => {

    let formRows: IDynamicFormRow[] = [
        {
            label: "groups.form.name_public",
            keyName: "name_public",
            Component: FormTextBox,
            registerOptions:
            {
                required: true,
            },
            gridColumnOptions: { formCol: 12 }
        },
        {
            label: "groups.form.description",
            keyName: "description",
            Component: FormTextBox,
            inputProperties: {
                type: 'text',
                multiline: true,
                rows: 4,
            },
            gridColumnOptions: {
                formCol: 12
            },
        },
        {
            label: "groups.form.nickname",
            keyName: "nickname",
            Component: FormTextBox,
            registerOptions:
            {
                required: true,
                validate: (value: string) => validateGroupURL(value , t)      
            },
            inputProperties: {
                type: 'text',
                InputProps:{
                    startAdornment: (
                        <InputAdornment position="start">
                          {`https://pay.yoello.com/g/`}
                        </InputAdornment>
                      ),
                }
            },
            gridColumnOptions: {
                formCol: 12
            },
        },
        {
            label: "groups.form.venues",
            keyName: "venues",
            Component: FormTags,
            formProps: {
                selectOptions: venues as Partial<IVenue>[],
                getOptionLabel: (option: Partial<IVenue>) => option.venue_name,
                multiple: true,
                selectKeyValue: "id",
                onInputChange : (event:any) => setInputValue(event.target.value as string),
                loading:loading
            },
            gridColumnOptions: {
                formCol: 12
            },
        },
        {
            label: "groups.form.language_id",
            keyName: "language_id",
            Component: FormSelect,
            formProps: {
              selectOptions: languages
                ? languages.map((language: ILanguage) => ({
                  name: t(`languages.${language.iso_code}`),
                  value: language.id,
                }))
                : [],
            },
            inputProperties: { required: true },
            gridColumnOptions: { formCol: 12 },
            registerOptions: {
              required: true,
              pattern: /(.|\s)*\S(.|\s)*/,
            },
          }
 
    ];

    // if(!update){
    //     formRows.push({
    //         label: "",
    //         keyName: "info",
    //         Component: () => <AlertStatusCard alertProps={{ icon: <InfoCircleIcon />, severity: 'info', className: "" }}
    //         alertMessage={t('groups.form.info')}
    //     />
    //     })
    // }
    return formRows
};

